BusinessClassPopOverAdView = require 'views/ads/business-class-pop-over-ad-view'
adGoogleApps = require 'views/templates/ad_business_class_google_apps'
Controller = require 'controller'

module.exports = class BusinessClassGoogleAppsAdView extends BusinessClassPopOverAdView
  @adId: 'AddOrganizationMemberBC'
  @isEligible: (member, org) ->
    org? && !org.isPremium()

  copyHtml: ->
    data = {}
    data.upgradeUrl = Controller.getOrganizationBillingUrl(@model)
    adGoogleApps(data)



// WEBPACK FOOTER //
// ./app/scripts/views/ads/business-class-google-apps-ad-view.coffee